import axios from 'axios';
import Lockr from 'lockr';
import { composeFormData } from './form';

const api = axios.create({
  baseURL: '/api/v1',
  timeout: 600 * 1000,
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest',
    }
  }
});

api.postFormData = function (url, data, config) {
  const formData = composeFormData(data);

  return this.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...config,
  });
}

export const setApiToken = (token) => {
  api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  Lockr.set('token', token);
}

let errorCallback = null;
export const catchUnauthorized = (callback) => {
  errorCallback = callback;
}

api.interceptors.response.use((response) => {
  return response;
}, function (error) {
  if (error.response.status == 401) {
    errorCallback ? errorCallback(error) : null;
  }

  return Promise.reject(error);
});

export default api;
